import { lazy } from "react";

// const SettlementsList = lazy(() => import('../views/settlements/index'))
const ScheduledPaymentsList = lazy(() => import('../views/scheduled-payments/scheduled-payments-list'));
const Businesses = lazy(() => import('../views/businesses/businesses'))
const Subscriptions = lazy(() => import('../views/subscriptions/subscriptions-list'));
const Indexing = lazy(() => import('../views/indexing/indexing'));
const Countries = lazy(() => import('../views/countries/countries'))
const Customers = lazy(() => import('../views/customers/customers'))
const Verification = lazy(() => import('../views/verifications/index-verification'))
const DLRs = lazy(() => import('../views/dlrs/index'))
const EmailTemplate = lazy(() => import('../views/email-template/index'))
const Industries = lazy(() => import('../views/industry/index'))
const Payments = lazy(() => import('../views/payments/payments'))
const PlatformReports = lazy(() => import('../views/platform-reports/index'))
const BusinessCustomersList = lazy(() => import('../views/business-customers/business-customers-list'))
const Banks = lazy(() => import('../views/banks/index'))
const Invoices = lazy(() => import('../views/invoices/invoices-list'))
const WhatsAppEmbeddedSignup = lazy(() => import('../views/whatsapp/embedded-signup'))

let ThemeRoutes = [
  // {
  //   path: "/settlements",
  //   name: "settlements",
  //   state: "settlementsPages",
  //   icon: "mdi mdi-wallet",
  //   component: SettlementsList,
  // },

  {
    path: "/businesses",
    name: "business",
    icon: "mdi mdi-briefcase",
    component: Businesses,
  },
  {
    path: "/scheduled-payments",
    name: "schedule",
    icon: "mdi mdi-calendar",
    component: ScheduledPaymentsList,
  },
  {
    path: "/payments",
    name: "payments",
    icon: "mdi mdi-wallet",
    component: Payments,
  },
  {
    path: "/platform-reports",
    name: "platform_reports",
    icon: "mdi mdi-chart-bar",
    component: PlatformReports,
    adminOnly: true,
  },
  {
    path: "/invoices",
    name: "invoices",
    icon: "mdi mdi-receipt",
    component: Invoices,
    adminOnly: true,
  },
  {
    path: "/subscriptions",
    name: "subscriptions",
    icon: "mdi mdi-account",
    component: Subscriptions,
  },
  {
    path: "/indexing",
    name: "indexing",
    icon: "fas fa-list-alt",
    component: Indexing,
    adminOnly: true,
  },
  {
    path: "/countries",
    name: "countries",
    icon: "fas fa-map",
    component: Countries,
    adminOnly: true,
  },
  {
    path: "/industries",
    name: "industries",
    icon: "fas fa-industry",
    component: Industries,
    adminOnly: true,
  },
  {
    path: "/banks",
    name: "banks",
    icon: "fas fa-university",
    component: Banks,
    adminOnly: true,
  },
  {
    path: "/customers",
    name: "customers",
    icon: "fas fa-users",
    component: Customers,
  },
  {
    path: "/business-customers",
    name: "business_customers",
    icon: "mdi mdi-account-multiple",
    component: BusinessCustomersList,
  },
  {
    path: "/verifications",
    name: "verifications",
    icon: "fas fa-file",
    component: Verification,
    adminOnly: true,
  }, {
    path: "/dlrs",
    name: "dlrs",
    icon: "fas fa-globe",
    component: DLRs,
  }, {
    path: "/emailTemplate",
    name: "email_template",
    icon: "fas fa-envelope",
    component: EmailTemplate,
    adminOnly: true,
  },
  {
    path: "/whatsapp",
    name: "whatsapp",
    icon: "fab fa-whatsapp",
    component: WhatsAppEmbeddedSignup,
    adminOnly: true,
  },

]

export default ThemeRoutes;